export default __webpack_public_path__ + "static/img/vogue_scene_animated_0600.a696333.jpg";